import { InvoiceTypes } from '../types/invoice-type.type';
import { mapSegmentInvoiceToTableRow } from './map-segment-invoice-to-table-row.util';
import { mapOrganizationInvoiceToTableRow } from './map-organization-invoice-to-table-row.util';
import type { Invoice } from '../types/invoice.type';
import type { InvoiceStatus } from '../types/invoice-status.type';
import type { InvoiceTableRow } from '../components/Tables/InvoiceListTable.component';

type Options = {
  onChangeStatus: (invoiceId: string, nextStatus: InvoiceStatus) => void | Promise<void>;
};

export function mapInvoiceToTableRow(invoice: Invoice, options: Options): InvoiceTableRow {
  switch (invoice.type) {
    case InvoiceTypes.SEGMENT:
      return mapSegmentInvoiceToTableRow(invoice, options);
    case InvoiceTypes.ORGANIZATION:
      return mapOrganizationInvoiceToTableRow(invoice, options);
    default: {
      const _exhaustive: never = invoice;
      throw new Error(`Unsupported invoice type: ${(_exhaustive as { type: string }).type}`);
    }
  }
}
